console.log('✅ pre-footerlinks.js loaded successfully!');

import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { loadTextTranslations } from '../../js/translator.js';
import { appState } from '../../js/state.js';
import { loadRoutes } from '../../js/router-routes-manager.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

//let _tempTextTranslator = null;
//export async function initTempTextTranslator(lang) {
//    _tempTextTranslator = await loadTextTranslations(lang);
//}

//let _tempLinksTranslator = null;
//export async function initTempLinksTranslator(lang) {
//    _tempLinksTranslator = await initLinksTranslator(lang);
//}

export async function buildComponentPreFooterLinks() {
  const lang = appState.SiteLanguageCookie;
  console.log(
    `🔄 Building Component: buildComponentPreFooterLinks - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    //await initTempTextTranslator(lang);
    //await initTempLinksTranslator(lang);

    // Dynamically import the shared helper,
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "translation-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyOurStore: textkeyOurStore,
      keyAboutUs: textkeyAboutUs,
      keyArticlesNBlog: textkeyArticlesNBlog,
      keyAnnouncements: textkeyAnnouncements,
      keyContactUs: textkeyContactUs,
      keySitemap: textkeySitemap,
      keyPaymentProtection: textkeyPaymentProtection,
      keyBecomeASeller: textkeyBecomeASeller,
      keyCreateStore: textkeyCreateStore,
      keyCreateBusinessAccount: textkeyCreateBusinessAccount,
      keyMyAccount: textkeyMyAccount,
      keyRegister: textkeyRegister,
      keyMyOrders: textkeyMyOrders,
      keyAddresses: textkeyAddresses,
      keyShoppingCart: textkeyShoppingCart,
      keyWishlist: textkeyWishlist,
      keyMyStore: textkeyMyStore,
      keyDeliveryNReturns: textkeyDeliveryNReturns,
      keyTrackYourOrder: textkeyTrackYourOrder,
      keyRequestAReplacement: textkeyRequestAReplacement,
      keyProductReviews: textkeyProductReviews,
      keyRaiseAnIssue: textkeyRaiseAnIssue,
      keyReturnsNRefunds: textkeyReturnsNRefunds,
      keyCustomerService: textkeyCustomerService,
      keyFAQs: textkeyFAQs,
    } = _tempTextTranslator;

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyAboutUs: linkkeyAboutUs,
      keyBlog: linkkeyBlog,
      keyContactUs: linkkeyContactUs,
      keySiteMap: linkkeySiteMap,
      keyPaymentProtection: linkkeyPaymentProtection,
      keySell: linkkeySell,
      keyCreateStore: linkkeyCreateStore,
      keyCreateBusinessAccount: linkkeyCreateBusinessAccount,
      keyRegister: linkkeyRegister,
      keyDashboard: linkkeyDashboard,
      keyMyOrders: linkkeyMyOrders,
      keyMyAddresses: linkkeyMyAddresses,
      keyShoppingCart: linkkeyShoppingCart,
      keyMyWishlist: linkkeyMyWishlist,
      keyMyStore: linkkeyMyStore,
      keyMyReturns: linkkeyMyReturns,
      keyMyProductReviews: linkKeyMyProductReviews,
      keyFAQs: linkkeyFAQs,
    } = _tempLinksTranslator;

    const lowerCaseAnnouncements = textkeyAnnouncements.toLowerCase();

    const announcementsCustomLink = `${linkkeyBlog}/23/${lowerCaseAnnouncements}`;

    const html = `
            <div ID="MainFooter" class="MainFooterWrapper">
                <div class="footerUsefulLinksWrapper">
                    <div class="footer-row">
                        <div class="footer-col">
                            <span>${textkeyOurStore}</span>
                            <a href="${linkkeyAboutUs}">${textkeyAboutUs}</a>
                            <a href="${linkkeyBlog}">${textkeyArticlesNBlog}</a>
                            <a href="${announcementsCustomLink}">${textkeyAnnouncements}</a>
                            <a href="${linkkeyContactUs}">${textkeyContactUs}</a>
                            <a href="${linkkeySiteMap}">${textkeySitemap}</a>
                            <a href="${linkkeyPaymentProtection}">${textkeyPaymentProtection}</a>
                            <a href="${linkkeySell}">${textkeyBecomeASeller}</a>
                            <a href="${linkkeyCreateStore}">${textkeyCreateStore}</a>
                            <a href="${linkkeyCreateBusinessAccount}">${textkeyCreateBusinessAccount}</a>
                        </div>

                        <div class="footer-col">
                            <span>${textkeyMyAccount}</span>
                            <a href="${linkkeyRegister}">${textkeyRegister}</a>
                            <a href="${linkkeyDashboard}">${textkeyMyAccount}</a>
                            <a href="${linkkeyMyOrders}">${textkeyMyOrders}</a>
                            <a href="${linkkeyMyAddresses}">${textkeyAddresses}</a>
                            <a href="${linkkeyShoppingCart}">${textkeyShoppingCart}</a>
                            <a href="${linkkeyMyWishlist}">${textkeyWishlist}</a>
                            <a href="${linkkeyMyStore}">${textkeyMyStore}</a>
                        </div>

                        <div class="footer-col">
                            <span>${textkeyDeliveryNReturns}</span>
                            <a href="${linkkeyMyOrders}">${textkeyTrackYourOrder}</a>
                            <a href="${linkkeyMyReturns}">${textkeyRequestAReplacement}</a>
                            <a href="${linkKeyMyProductReviews}">${textkeyProductReviews}</a>
                            <a href="${linkkeyContactUs}">${textkeyRaiseAnIssue}</a>
                            <a href="${linkkeyMyReturns}">${textkeyReturnsNRefunds}</a>
                        </div>

                        <div class="footer-col">
                            <span>${textkeyCustomerService}</span>
                            <a href="${linkkeyFAQs}">${textkeyFAQs}</a>
                            <a href="${linkkeyContactUs}">${textkeyContactUs}</a>
                        </div>
                    </div>
                </div>
            </div>
        `;

    console.log('✅ Pre-footer built successfully.');

    return html;
  } catch (err) {
    console.error('❌ Error building pre-footer links:', err);
    return '<div>Pre-footer links could not be loaded.</div>';
  }
}
